import {
  Row,
  Col
} from 'reactstrap'
import {
  InputField,
  ToggleField
} from 'components'
import { useFormikContext } from 'formik'

import PropTypes from 'prop-types'
import { InputSelectOptions } from 'components/molecules'
import { VOUCHER_CATEGORIES } from 'domains/voucher/constants'

const propTypes = {
  initialImageSrc : PropTypes.string,
  image           : PropTypes.object,
  setImage        : PropTypes.func
}

const defaultProps = {
  initialImageSrc : '',
  image           : {},
  setImage        : () => { alert('image button selected') }
}

const VoucherRuleGeneralFields = () => {
  // Get current values in the form for conditional rendering
  // Prevents having to have a state in this component
  const {
    initialValues,
    setValues,
    setTouched,
    touched,
    values
  } = useFormikContext()

  const handleChangeIsHourLimit = () => {
    const newIsHourLimit = !values.is_hour_limit
    setValues({
      ...values,
      is_hour_limit   : newIsHourLimit,
      hour_limit_from : newIsHourLimit == true ? initialValues.hour_limit_from : '',
      hour_limit_to   : newIsHourLimit == true ? initialValues.hour_limit_to : ''
    })
    setTouched({
      ...touched,
      hour_limit_from : false,
      hour_limit_to   : false
    })
  }

  const handleChangeIsDayLimit = () => {
    const newIsDayLimit = !values.is_day_limit
    setValues({
      ...values,
      is_day_limit : newIsDayLimit,
      day_limit    : newIsDayLimit == true ? initialValues.day_limit : ''
    })
    setTouched({
      ...touched,
      day_limit: false
    })
  }

  return (
    <Row>
      <Col md='4'>
        <InputField
          type='text'
          label='Voucher Name'
          name='name'
          placeholder='End of Season Sale 88k'
          formText='Name of the voucher that Customer will see.'
          required={ true }
        />

        <InputField
          type='textarea'
          label='Description'
          name='description'
          rows={ 8 }
          placeholder={ 'Voucher for customers that being shared on boot event' }
          formText='Use ENTER key to separate lines to make it easy to read. Drag bottom right corner of the input to enlarge.'
          required={ true }
        />

        <InputField
          type='textarea'
          label='Term and Condition'
          name='terms'
          rows={ 8 }
          formText={ 'Use ENTER key to separate lines to make it easy to read. Drag bottom right corner of the input to enlarge.' }
          required={ true }
        />

        <InputField
          type='select'
          name={ 'category' }
          label='Category'
          required={ true }
          formText={ <>
            <ul>
              <li><strong>{ 'Brand Marketing' }</strong> - Voucher yang dibuat untuk keperluan Brand Marketing</li>
              <li><strong>{ 'Digital Marketing' }</strong> - Voucher yang dibuat untuk keperluan Digital Marketing</li>
              <li><strong>{ 'Marketing' }</strong> - Voucher yang dibuat untuk keperluan Marketing</li>
              <li><strong>{ 'Online Campaign' }</strong> - Voucher dari event Online seperti social media campaign</li>
              <li><strong>{ 'Otp' }</strong> - Voucher voucher yang didapat setelah user sukses registrasi akun Tinkerlust melalui verifikasi OTP</li>
              <li><strong>{ 'Psa' }</strong> - voucher yang dibuat untuk keperluan personal sales assistant</li>
              <li><strong>{ 'Refund' }</strong> - Voucher yang dibuat setelah proses refund di setujui</li>
              <li><strong>{ 'Others' }</strong> - Voucher yang tidak termasuk kedalam category diatas</li>
            </ul>
          </> }
        >
          <InputSelectOptions options={ VOUCHER_CATEGORIES } />
        </InputField>

      </Col>

      <Col md='4'>
        <ToggleField
          id={ 'is_active' }
          name={ 'is_active' }
          label={ 'Is Active?' }
          required={ true }
          formText={ <>
            <strong>Yes: </strong>Shown on Checkout and/or search results. Voucher can be used.
            <br />
            <strong>No: </strong>Hidden in checkout page & search. Voucher cannot be used.
          </> }
        />

        <ToggleField
          id={ 'show_on_checkout' }
          name={ 'show_on_checkout' }
          label='Show on Checkout?'
          required={ true }
          formText={ <>
            <strong>Yes: </strong>Displays voucher in checkout page.
            <br />
            <strong>No: </strong>Search using the Voucher Code to apply voucher.
          </> }
        />

        <InputField
          type='select'
          name={ 'device' }
          label='Device'
          required={ true }
          formText={ <>
            <strong>All: </strong>Voucher applicable for all device.
            <br />
            <strong>Website: </strong>Voucher only applicable on the website.
            <br />
            <strong>Mobile: </strong>Voucher only applicable on the mobile app.
          </> }
        >
          <option value={ 'all' }>All</option>
          <option value={ 'website' }>Website</option>
          <option value={ 'mobile' }>Mobile</option>
        </InputField>

        <ToggleField
          id={ 'is_for_new_customer' }
          name={ 'is_for_new_customer' }
          label={ 'For New Customer?' }
          required={ true }
          formText={ <>
            <strong>Yes: </strong>{ 'Only Customer who have not ordered before can use this voucher.' }<br/>
            <strong>No: </strong>{ 'All Customers can use this voucher.' }
          </> }
        />

        <ToggleField
          id={ 'is_refundable' }
          name={ 'is_refundable' }
          label='Is Refundable?'
          required={ true }
          formText={ <>
            <div><strong>Yes: </strong>Customer will receive the discount amount during a refund.</div>
            <div><strong>No: </strong>Customer will not receive the discount amount during a refund.</div>
            <div><strong>Marketing/Merchandising: </strong>Campaigns should always set this to NO.</div>
            <div><strong>CS/Ops: </strong>Set to YES when creating a Refund Voucher manually.</div>
          </>
          }
        />
      </Col>

      <Col md='4'>
        <Row>
          <Col md='6'>
            <InputField
              type='date'
              label='Start Date'
              name='from_date'
              formText={ <>
                { 'Tanggal mulai berlaku voucher.' }
                <br />
                { 'Jika kosong, voucher akan selalu bisa digunakan selama statusnya aktif.' }
              </>
              }
            />
          </Col>
          <Col md='6'>
            <InputField
              label='Expiry Date'
              type='date'
              name='to_date'
              formText={ <>
                { 'Tanggal akhir berlakunya voucher.' }
                <br />
                { 'Jika kosong, voucher akan selalu bisa digunakan selama statusnya aktif.' }
              </>
              }
            />
          </Col>
        </Row>

        <ToggleField
          id={ 'is_hour_limit' }
          name={ 'is_hour_limit' }
          label={ 'Hanya berlaku di jam tertentu' }
          required={ true }
          onChange={ handleChangeIsHourLimit }
          formText={ <>
            <strong>Yes: </strong>{ 'Voucher hanya dapat digunakan di jam tertentu.' }<br/>
            <strong>No: </strong>{ 'Voucher dapat digunakan kapan saja.' }
          </> }
        />
        <Row>
          <Col md="6">
            <InputField
              label='Dari jam'
              type='time'
              name='hour_limit_from'
              disabled={ !values.is_hour_limit }
            />
          </Col>
          <Col md="6">
            <InputField
              label='Sampai jam'
              type='time'
              name='hour_limit_to'
              disabled={ !values.is_hour_limit }
            />
          </Col>
        </Row>

        <ToggleField
          id={ 'is_day_limit' }
          name={ 'is_day_limit' }
          label={ 'Hanya berlaku di hari tertentu' }
          required={ true }
          onChange={ handleChangeIsDayLimit }
          formText={ <>
            <strong>Yes: </strong>{ 'Voucher hanya dapat digunakan di hari tertentu.' }<br/>
            <strong>No: </strong>{ 'Voucher dapat digunakan kapan saja.' }
          </> }
        />

        <InputField
          type='select'
          label='Hari berlaku voucher'
          name='day_limit'
          disabled= { !values.is_day_limit }
        >
          <option value={ null }>--pilih hari--</option>
          <option value={ 'MONDAY' }>Senin</option>
          <option value={ 'TUESDAY' }>Selasa</option>
          <option value={ 'WEDNESDAY' }>Rabu</option>
          <option value={ 'THURSDAY' }>Kamis</option>
          <option value={ 'FRIDAY' }>Jumat</option>
          <option value={ 'SATURDAY' }>Sabtu</option>
          <option value={ 'SUNDAY' }>Minggu</option>
        </InputField>
      </Col>
    </Row>
  )
}

VoucherRuleGeneralFields.propTypes    = propTypes
VoucherRuleGeneralFields.defaultProps = defaultProps

export default VoucherRuleGeneralFields
